import React from "react";
import { Alert, Descriptions } from "antd";
import useLang from "../../../hooks/useLang";
import { thousandsFormatter } from "../../../utils/formatters";
import { fillTemplate } from "./payoutFormat";

interface PayoutReviewStepProps {
	driverCount: number;
	excludedCount: number;
	total: number;
	description: string;
}

const PayoutReviewStep = ({
	driverCount,
	excludedCount,
	total,
	description,
}: PayoutReviewStepProps) => {
	const { strings } = useLang("driver");
	const copy = strings?.bulkPayout;

	return (
		<div className="flex flex-col gap-5 py-2">
			<Alert
				type="warning"
				showIcon
				message={copy?.reviewTitle ?? "Confirm the payment"}
				description={fillTemplate(
					copy?.reviewMessage ??
						"A payment will be recorded for {count} drivers, {total} in total. It cannot be undone from this screen.",
					{ count: driverCount, total: thousandsFormatter(total) }
				)}
			/>

			<Descriptions column={1} bordered size="middle">
				<Descriptions.Item label={copy?.statToPay ?? "Will be paid"}>
					<b>{driverCount}</b>
				</Descriptions.Item>
				<Descriptions.Item label={copy?.statTotal ?? "Total to pay"}>
					<b className="text-[#4F16C2]">
						{thousandsFormatter(total)}
					</b>
				</Descriptions.Item>
				<Descriptions.Item
					label={copy?.excludedTitle ?? "Excluded drivers"}
				>
					{excludedCount}
				</Descriptions.Item>
				<Descriptions.Item
					label={copy?.descriptionLabel ?? "Description"}
				>
					<span className="break-words">{description}</span>
					<span className="text-gray-400">
						{" "}
						{copy?.yourNameSuffix ?? "(+ your name)"}
					</span>
				</Descriptions.Item>
			</Descriptions>

			<div className="text-sm text-gray-500">
				{copy?.reviewAmountNote ??
					"Each driver is paid their balance at the moment you confirm, so every paid driver ends at zero."}
			</div>
		</div>
	);
};

export default PayoutReviewStep;
